import React from 'react';
import PropTypes from 'prop-types';
import './reset.css';
import * as styles from './Layout.scss';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import SideMenu from '../SideMenu/SideMenu';
import { throttle } from "lodash";

const Layout = (props) => (
  <div className="layout">
    <Header className="is-top"></Header>
    <SideMenu></SideMenu>
    <main>
      {props.children}
    </main>
    <Footer></Footer>
  </div>
);

Layout.propTypes = {};

Layout.defaultProps = {};

export default Layout;
